import Swal from 'sweetalert2';
import { getAllProducts } from '../services/ProductServices';
import { getConcreteEstimatorDetails } from '../services/ConcreteEstimatorServices';
import { buildQuotationPrefillFromEstimate } from './concreteEstimatorToQuotation';

export async function navigateToQuotationFromEstimate(cookies, navigate, estimateId) {
    try {
        const [estimate, productRes] = await Promise.all([
            getConcreteEstimatorDetails(cookies, estimateId),
            getAllProducts(cookies),
        ]);
        const productList = productRes.product_list || [];
        const prefill = buildQuotationPrefillFromEstimate(estimate, productList);

        if (!prefill.inputs.customer_id) {
            const proceed = await Swal.fire({
                title: 'No customer on estimate',
                text: 'The quotation will open with quantities pre-filled. You can select customer and rates before saving.',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Continue',
            });
            if (!proceed.isConfirmed) return;
        }

        navigate('/Quotation', { state: { quotationPrefill: prefill } });
    } catch (err) {
        Swal.fire('Error', err?.response?.data?.detail || err.message || 'Could not load estimate', 'error');
    }
}

export function navigateToQuotationFromEstimateData(navigate, estimate, productList) {
    const prefill = buildQuotationPrefillFromEstimate(estimate, productList);
    navigate('/Quotation', { state: { quotationPrefill: prefill } });
}
